






























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import {
  SubscriptionActivityRulesConfig,
  SubscriptionCategory,
  SubscriptionRulesConfig,
} from '@subscriptions/interfaces/subscription-category';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import { SubscriptionOnlineBookingConfig } from '@subscriptions/interfaces/subscription-online-booking-config';
import BpcSubscriptionOnlineBookingConfigForm from '@subscriptions/components/forms/subscription-online-booking-config-form.vue';
import BpcSubscriptionActivityRulesForm from '@subscriptions/components/forms/subscription-activity-rules-form.vue';
import ImpactOnSubscriptionsModal from '../modals/impact-on-subscriptions-modal/impact-on-subscriptions-modal.vue';
import ModulesHelper from '@core/services/modules.helper';
import { CenterSetting } from '@core/interfaces/center-setting';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import BpcAccessibleResourceItem from '@access-control/components/forms/accessible-resource-item/accessible-resource-item.vue';

@Component({
  name: 'bc-subscription-category-form',
  components: {
    'bpc-input-group': InputGroup,
    'bpc-entity-select': EntitySelect,
    'bpc-std-form': StdForm,
    BpcSubscriptionOnlineBookingConfigForm,
    BpcSubscriptionActivityRulesForm,
    'bc-impact-on-subscriptions-modal': ImpactOnSubscriptionsModal,
    BpcAccessibleResourceItem,
  },
})
export default class SubscriptionCategoryForm extends Vue {
  $refs: {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: Partial<SubscriptionCategory>;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      onModelLoaded(): void;
      extraData: string | any;
      formProvider: EntityFormProvider;
      errorsObject: object;
    };
  };
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Number, default: null }) readonly entityId: number;

  // Data properties
  formModel: Partial<SubscriptionCategory> = {};
  entityName = 'subscription-category';
  showImpactOnSubscriptionsModal = false;
  oldPaymentDay: number;
  oldBufferPaymentDay: number;

  public showOnlineBookingConfigForm = false;
  public showActivityRulesForm = false;
  public onlineBookingConfig: SubscriptionOnlineBookingConfig = null;
  public activityRulesConfig: SubscriptionActivityRulesConfig = null;
  public subscriptionRulesConfig: SubscriptionRulesConfig = null;

  accessibleResources: Array<{
    resource_id: number;
    schedule_id?: number | null;
  }> = [];

  // Computed properties
  get articleLabel() {
    if (this.showPaymentFrequencyField) {
      return 'global.subscription_category.article_renewal_payment.label';
    } else {
      return 'global.subscription_category.article.label';
    }
  }

  get numberCreditsLabel() {
    switch (this.formModel.type) {
      case 'time_based':
        return 'global.subscription_category.number_minutes.label';
      default:
        return 'global.subscription_category.number_credits.label';
    }
  }

  get showNumberCreditsField(): boolean {
    return ['subscription', 'time_based'].includes(this.formModel?.type);
  }

  get showPaymentFrequencyField(): boolean {
    return this.formModel?.enable_periodic_payment;
  }

  get articleFieldConfig() {
    return {
      fieldPath: 'article',
      fieldReadPath: 'article',
      name: 'article',
      label: 'global.subscription_category.article.label',
      inputType: 'entity-select',
      options: [],
      id: 'global-subscription-category__article',
      veeValidation: true,
      rules: ['required_if:in_pos,true', 'nullable'],
      warningRules: [],
      tags: [],
      fieldAttributes: {
        autocomplete: 'off',
      },
      fieldClass: 'global-subscription-category__article--input',
      showError: true,
      errorClass: 'global-subscription-category__article--input-error',
      errorAttributes: [],
      showHelp: false,
      helpClass: 'global-subscription-category__article--input-help',
      helpAttributes: [],
      help: 'global.subscription_category.article.help',
      showFeedback: true,
      feedbackClass: 'global-subscription-category__article--input-feedback',
      feedbackAttributes: [],
      feedback: 'global.subscription_category.article.feedback',
      showLabel: true,
      labelClass: 'global-subscription-category__article--input-label',
      labelAttributes: {
        for: 'global-subscription-category__article',
        cols: 12,
        'sr-only': false,
        align: 'left',
        size: 'md',
      },
      wrapperAttributes: {
        class: {
          'col-sm-12': true,
        },
      },
      filters: [
        {
          filterField: 'article_type',
          modelField: null,
          value: ['subscription'],
        },
        {
          filterField: 'status',
          modelField: null,
          value: ['active'],
        },
      ],
      mediaCollection: [],
      disabledByTags: [],
      showDefaultValueSwitch: false,
      defaultValueSwitchValue: 'default',
      conditionalClass: null,
      tab: 'subscription',
      iconFolder: '',
      selectLabel: 'name',
      selectEntity: 'article',
      selectMultiple: false,
      withTableSearch: true,
      displayConfigName: 'search',
      withNew: true,
      formConfigName: 'default',
      order: 170,
    };
  }

  get numberCreditsFieldConfig() {
    return {
      fieldPath: 'total_credits',
      errorFieldPath: 'total_credits',
      fieldReadPath: 'total_credits',
      name: 'total_credits',
      label: 'global.subscription.total_credits.label',
      id: 'global-subscription__total-credits',
      rules: ['nullable'],
      fieldAttributes: {
        autocomplete: 'off',
        type: 'number',
        step: '1',
      },
      fieldClass: 'global-subscription__total-credits--input',
      labelAttributes: {
        for: 'global-subscription__total-credits',
        cols: 12,
        'sr-only': false,
        align: 'left',
        size: 'md',
      },
      defaultValue: 999,
    };
  }

  get accessibleResourcesConfig() {
    return {
      label: 'global.subscription_category.subscription_category_accessible_resource_ids.label',
      selectLabel: 'name',
      selectMultiple: false,
      selectEntity: 'resource',
      defaultValue: [],
      filters: [
        {
          filterField: 'has_access_control',
          modelField: null,
          value: 1,
        },
      ],
      conditionalShowMode: 'and',
      conditionalShow: [
        {
          fieldPath: 'enable_access_control_sync',
          operator: '=',
          value: 1,
        },
        {
          formModel: 'accessControlConfig',
          fieldPath: 'access_control_service',
          operator: '=',
          value: 'internal',
        },
      ],
      showHelp: true,
      help: 'global.subscription_category.subscription_category_accessible_resource_ids.help',
    };
  }

  get subscriptionScheduleConfig() {
    return {
      label: 'centers.resources.access_control_schedule.label',
      rules: ['nullable'],
      inputType: 'entity-select',
      selectLabel: 'name',
      selectEntity: 'schedule',
      selectMultiple: false,
      selectClearable: true,
      filters: [
        {
          filterField: 'type',
          modelField: null,
          value: 'access_control',
        },
      ],

      conditionalShow: {
        formModel: 'accessControlConfig',
        fieldPath: 'access_control_service',
        operator: '=',
        value: 'internal',
      },
      module: ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME,
    };
  }

  get selectedRenewableSubscription(): boolean {
    return this.formModel?.enable_periodic_payment || false;
  }

  get errorsObject(): object {
    return this.$refs.stdForm.errorsObject;
  }

  get selectedDisciplinesForOnlineBookingIds() {
    return this.formModel?.disciplines?.map(discipline => discipline?.id) || [];
  }
  get selectedResourcesForOnlineBookingIds() {
    return this.formModel?.resources?.map(resource => resource?.id) || [];
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get accessControlModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCESS_CONTROL_MODULE_NAME);
  }

  get isInternalAccessControlService(): boolean {
    return this.accessControlConfig?.access_control_service === 'internal';
  }
  get displayResourceSheculeRepeater(): boolean {
    return (
      this.accessControlModuleActivated &&
      this.isInternalAccessControlService &&
      this.formModel.enable_access_control_sync
    );
  }

  // Methods
  onCloseImpactOnSubscriptionsModal() {
    this.showImpactOnSubscriptionsModal = false;
  }

  saveEntity() {
    if (this.formModel && this.formModel.id && this.formModel.payment_day !== this.oldPaymentDay) {
      this.showImpactOnSubscriptionsModal = true;
    } else this.$refs.stdForm.saveEntity();
  }

  saveFromImpactOnSubscriptionsModal($event: boolean) {
    this.showImpactOnSubscriptionsModal = false;
    const oldFormModel = this.$refs.stdForm.formModel;
    const newFormModel = {
      ...oldFormModel,
      update_subscriptions: $event,
    };
    this.$set(this.$refs.stdForm, 'formModel', newFormModel);
    this.$refs.stdForm.saveEntity();
  }

  actionAfterPrepareToSave(entity: Partial<SubscriptionCategory>): Partial<SubscriptionCategory> {
    if (entity.article) {
      entity.article_id = entity.article?.id;
    } else {
      entity.article_id = null;
    }

    if (entity.option_group) {
      delete entity.option_group;
    }

    if (entity.optionGroup) {
      delete entity.optionGroup;
    }

    entity.accessible_resources = this.accessibleResources;

    entity.onlineBookingConfig = this.onlineBookingConfig;
    entity.activityRulesConfig = this.activityRulesConfig;
    entity.subscriptionRulesConfig = this.subscriptionRulesConfig;
    return entity;
  }

  onFormSaved($event) {
    this.$emit('entity-saved', $event);
  }

  onSavingEntity($event) {
    this.$emit('saving-entity', $event);
  }

  onDeleteMediaFile($event) {
    this.$emit('delete-media-file', $event);
  }

  onModelLoaded(formModel: Partial<SubscriptionCategory>) {
    if (this.formModel) {
      this.oldPaymentDay = this.formModel.payment_day;
      this.oldBufferPaymentDay = this.formModel.buffer_payment_day;
    }
    this.$nextTick().then(() => {
      if (!this.entityId) {
        // Only when it is a creation form
        this.formModel.number_credits = 999;
      }
      const bookingOptions =
        formModel?.optionGroup?.options?.booking || formModel?.option_group?.options?.booking;

      const activityRulesConfig =
        formModel?.optionGroup?.options.activity_session_attendee ||
        formModel?.option_group?.options?.activity_session_attendee;

      const subscriptionRulesConfig =
        formModel?.optionGroup?.options.subscription ||
        formModel?.option_group?.options?.subscription;

      this.onlineBookingConfig = bookingOptions || this.getDefaultResourceOnlineBookingConfig();
      this.activityRulesConfig = activityRulesConfig || this.getDefaultActivityRulesConfig();
      this.subscriptionRulesConfig = subscriptionRulesConfig;
      this.showOnlineBookingConfigForm = true;
      this.showActivityRulesForm = true;

      this.accessibleResources = formModel.accessible_resources || [];

      this.$emit('model-loaded');
    });
  }

  getDefaultResourceOnlineBookingConfig(): SubscriptionOnlineBookingConfig {
    return {
      allowed_durations: [60],
      max_time_before_booking: '14',
      min_time_before_booking: '0',
      allow_cancel_booking_event: false,
      min_time_before_cancellation: '24',
      membership_required: false,
      memberships_allow_booking: [],
      max_number_of_ongoing_upcoming_bookings_when_subscription_payment: '999',
      max_number_of_ongoing_bookings_per_week_when_subscription_payment: '999',
      min_time_between_two_bookings: '12',
      defaultValueSwitchModel: {
        allowed_durations: true,
        max_time_before_booking: true,
        min_time_before_booking: true,
        allow_cancel_booking_event: true,
        min_time_before_cancellation: true,
        membership_required: true,
        memberships_allow_booking: true,
        max_number_of_ongoing_upcoming_bookings_when_subscription_payment: true,
        max_number_of_ongoing_bookings_per_week_when_subscription_payment: true,
        min_time_between_two_bookings: true,
      },
    };
  }
  getDefaultActivityRulesConfig(): SubscriptionActivityRulesConfig {
    return {
      max_weekly_active_attendees: null,
      max_global_active_attendees: null,
      defaultValueSwitchModel: {
        max_weekly_active_attendees: true,
        max_global_active_attendees: true,
      },
    };
  }

  addAccessibleResource() {
    this.accessibleResources.push({
      resource_id: null,
      schedule_id: null,
    });
  }

  removeAccessibleResource(index: number) {
    this.accessibleResources.splice(index, 1);
  }

  onErrorSavingEntity(event) {
    const errorMsg = event?.response?.data?.message;
    if (errorMsg) {
      this.$bpcMessage.showErrorMessage({ text: this.$t(errorMsg).toString() });
    }
  }

  // Watchers
  @Watch('selectedRenewableSubscription')
  onChangeRenewableSubscription(value) {
    if (!value) {
      this.formModel.payment_frequency = null;
      this.formModel.payment_day = null;
    }
  }
}
